let disabling = false;

export class Scroll {
    static disable(instant = true) {
        let oldScrollY = window.pageYOffset,
            interval;
        const f = (first) => {
            if (!instant && window.pageYOffset !== oldScrollY) {
                first && (clearInterval(interval), (interval = setInterval(f, 200)));
                oldScrollY = window.pageYOffset;
                return;
            }

            const offset = document.body.getBoundingClientRect().top;
            document.documentElement.classList.add('disable-scroll');
            document.body.style.setProperty('top', offset + 'px');
            !instant && (clearInterval(interval), disabling = false);
        };

        (instant && (f(), instant)) || (interval = setInterval(f.bind(this, true), 500)) && (disabling = true);
    }

    static enable() {
        if (disabling) {
            setTimeout(() => {
                Scroll.enable();
            }, 200);
            return;
        }

        const offset = document.body.getBoundingClientRect().top;
        document.body.style.removeProperty('top');
        document.documentElement.classList.remove('disable-scroll');
        requestAnimationFrame(() => {
            offset !== document.body.getBoundingClientRect().top && window.scrollBy(0, -offset);
            setTimeout(() => {
                offset !== document.body.getBoundingClientRect().top && window.scrollBy(0, -offset);
            })
        })
    }
}